import React from 'react'

export const COLUMNS_DETALLE_ESPACIO_POR_CEREAL_LINEA_4 = [
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'espacioEnTnsLinea6',
    label: 'Linea 6 [Tns]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'espacioEnCamionesLinea6',
    label: 'Linea 6 [Camiones]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(0)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'espacioEnTnsLinea5',
    label: 'Linea 5 [Tns]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'espacioEnCamionesLinea5',
    label: 'Linea 5 [Camiones]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(0)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'espacioEnTnsLinea7',
    label: 'Linea 7 [Tns]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'espacioEnCamionesLinea7',
    label: 'Linea 7 [Camiones]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(0)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'espacioTotalEnTns',
    label: 'Total [Tns]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'espacioTotalEnCamiones',
    label: 'Total [Camiones]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(0)}`}
          </div>
        )
      }
    }
  }
]

export const COLUMNS_DETALLE_ESPACIO_POR_CEREAL_LINEA_4_TO_PRINT = [
  {
    name: 'cereal',
    label: 'Cereal',
    width: 40,
    mantenerCase: true
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: 40,
    mantenerCase: true
  },
  {
    name: 'espacioEnTnsLinea5',
    label: 'Espacio L 5 [Tns]',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'espacioEnCamionesLinea5',
    label: 'Espacio L 5 [Camiones]',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'espacioEnTnsLinea6',
    label: 'Espacio L 6 [Tns]',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'espacioEnCamionesLinea6',
    label: 'Espacio L 6 [Camiones]',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'espacioEnTnsLinea7',
    label: 'Espacio L 7 [Tns]',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'espacioEnCamionesLinea7',
    label: 'Espacio L 7 [Camiones]',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'espacioTotalEnTns',
    label: 'Espacio Total [Tns]',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'espacioTotalEnCamiones',
    label: 'Espacio Total [Camiones]',
    width: 60,
    mantenerCase: true
  }
]
